import axios from '../js/request';

const request = {
    // 注册
    Register: function (query) {
        return axios({
            url: '/api/u/ajaxregister',
            method: 'post',
            data: query
        })
    },
    //登录
    login: function (query) {
        return axios({
            url: '/api/u/ajaxlogin',
            method: 'post',
            data: query
        })
    },
    //验证码
    Validate: function (query) {
        return axios({
            url: '/api/u/regsendcode',
            method: 'post',
            data: query
        })
    },
    // 判断是否需要验证码
    Code: function (query) {
        return axios({
            url: '/api/u/checklogin',
            method: 'post',
            data: query
        })
    },
    // 判断手机号获取微信
    getWx: function (query) {
        return axios({
            url: '/api/u/GetRegisterWX',
            method: 'get',
            params: query
        })
    },
}
export {request}